export const messages = {
  en: {
    gold: {
      queryCondition: 'Query Conditions',
      communityNamePlaceholder: 'Please enter community name',
      communityIdPlaceholder: 'Please enter community ID',
      query: 'Query',
      communityGold: 'Community Gold',
      document: 'Document',
      goldAccount: 'Gold Account',
      propertyCompany: 'Property Company',
      communityName: 'Community Name',
      communityId: 'Community ID',
      balance: 'Balance',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete'
    },
    editGold: {
      edit: 'Edit',
      name: 'Name',
      namePlaceholder: 'Required, please enter name',
      amount: 'Amount',
      amountPlaceholder: 'Required, please enter amount',
      cancel: 'Cancel',
      save: 'Save',
      amountRequired: 'Amount is required',
      amountMaxLength: 'Amount cannot exceed 10 characters',
      idRequired: 'ID is required',
      updateSuccess: 'Update successful',
      updateFailed: 'Update failed'
    },
    deleteGold: {
      confirmOperation: 'Please confirm your operation!',
      confirmDeleteGold: 'Confirm to delete gold',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete!',
      deleteSuccess: 'Delete successful',
      deleteFailed: 'Delete failed'
    }
  },
  zh: {
    gold: {
      queryCondition: '查询条件',
      communityNamePlaceholder: '请输入小区名称',
      communityIdPlaceholder: '请输入小区编号',
      query: '查询',
      communityGold: '小区金币',
      document: '文档',
      goldAccount: '金币账号',
      propertyCompany: '物业公司',
      communityName: '小区名称',
      communityId: '小区编号',
      balance: '余额',
      operation: '操作',
      edit: '修改',
      delete: '删除'
    },
    editGold: {
      edit: '修改',
      name: '名称',
      namePlaceholder: '必填，请填写名称',
      amount: '金额',
      amountPlaceholder: '必填，请填写金额',
      cancel: '取消',
      save: '保存',
      amountRequired: '金额不能为空',
      amountMaxLength: '金额不能超过10位',
      idRequired: '编号不能为空',
      updateSuccess: '修改成功',
      updateFailed: '修改失败'
    },
    deleteGold: {
      confirmOperation: '请确认您的操作!',
      confirmDeleteGold: '确定删除金币',
      cancel: '点错了',
      confirmDelete: '确认删除!',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败'
    }
  }
}